import React from 'react';
import useStyles from './styles';

function CommonSpaced({ children, size = 'small', type = '', ...props }: CommonSpacedProps) {
  const classes = useStyles();

  return (
    <div className={classes[`${size}${type}`]} data-testid={props['data-testid']}>
      {children}
    </div>
  );
}

export function TopSpaced({ children, size = 'small' }: SpacedProps) {
  return (
    <CommonSpaced type="Top" size={size} data-testid="topSpaced">
      {children}
    </CommonSpaced>
  );
}

export function HorizontalSpaced({ children, size = 'small' }: SpacedProps) {
  return (
    <CommonSpaced type="Horizontal" size={size} data-testid="horizontalSpaced">
      {children}
    </CommonSpaced>
  );
}

export function VerticalSpaced({ children, size = 'small' }: SpacedProps) {
  return (
    <CommonSpaced type="Vertical" size={size} data-testid="verticalSpaced">
      {children}
    </CommonSpaced>
  );
}

export function VerticalSpacedList({ children, size = 'small' }: SpacedProps) {
  return (
    <>
      {React.Children.map(children, (component, index) =>
        index === React.Children.count(children) - 1 ? (
          <VerticalSpaced size={size}>{component}</VerticalSpaced>
        ) : (
          <TopSpaced size={size}>{component}</TopSpaced>
        )
      )}
    </>
  );
}

export function Spaced({ children, size = 'small' }: SpacedProps) {
  return (
    <CommonSpaced size={size} data-testid="spaced">
      {children}
    </CommonSpaced>
  );
}

export function LeftSpaced({ children, size = 'small' }: SpacedProps) {
  return (
    <CommonSpaced type="Left" size={size} data-testid="leftSpaced">
      {children}
    </CommonSpaced>
  );
}

export function RightSpaced({ children, size = 'small' }: SpacedProps) {
  return (
    <CommonSpaced type="Right" size={size} data-testid="rightSpaced">
      {children}
    </CommonSpaced>
  );
}
